import { render } from "./khutba.vue?vue&type=template&id=0220dd82"
import script from "./khutba.vue?vue&type=script&lang=js"
export * from "./khutba.vue?vue&type=script&lang=js"
script.render = render

export default script